import * as TYPE from './types';
import { ApplicationState } from '..';
import { BDNLocationSettings } from './models';

export const bdnLocationSettingsReducer = (
  state: ApplicationState['bdn_location_settings'] = {
    loading: true,
    error: false,
    dataIsLoaded: false,
    data: {} as BDNLocationSettings,
    metadata: {},
  },
  action: TYPE.BDNLocationSettingsActions,
): ApplicationState['bdn_location_settings'] => {
  switch (action.type) {
    case TYPE.BDN_LOCATIONS_STTTINGS_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case TYPE.GET_BDN_LOCATIONS_STTTINGS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
        dataIsLoaded: true,
      };
    case TYPE.BDN_LOCATIONS_STTTINGS_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errorDetails: action.payload,
      };
    case TYPE.UPDATE_BDN_LOCATIONS_STTTINGS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
        toastData: {
          content: 'location settings edited',
          type: 'info',
        },
      };
    case TYPE.UPDATE_BDN_LOCATIONS_STTTINGS_ERROR:
      return {
        ...state,
        loading: false,
        error: false,
        toastData: {
          content: action.payload.message ? action.payload.message : "Sorry, can't update BDN location settings.",
          type: 'error',
        },
      };
    default:
      return { ...state };
  }
};
